import { useMemo } from "react";
import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { useHistory } from "react-router-dom";

export const ButtonGoBack = () => {
	const history = useHistory();
	const showGoBack = useMemo(() => history.length > 1, [history]);

	return showGoBack ? (
		<HiOutlineArrowCircleLeft
			size={24}
			style={{
				marginRight: "16px",
				cursor: "pointer",
			}}
			onClick={() => history.goBack()}
		/>
	) : (
		<></>
	);
};
